import { QUERY_KEYS } from "@/libraries/constant";
import { getGroupQueryOptions, getGroupsQueryOptions } from "@/queries";
import { onlineManager } from "@tanstack/react-query";
import type { RouteContext } from "@tanstack/react-router";

export function getGroupLoader(ctx: RouteContext, id: any) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureQueryData(getGroupQueryOptions(id));
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_GROUP, id]);
}

export function getGroupsLoader(ctx: RouteContext) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureInfiniteQueryData(getGroupsQueryOptions());
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_GROUPS]);
}

export function getActiveGroupsLoader(ctx: RouteContext) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureInfiniteQueryData(
			getGroupsQueryOptions({ status: "active" }),
		);
	}
	return ctx.queryClient.getQueryData([
		QUERY_KEYS.GET_GROUPS,
		{ status: "active" },
	]);
}

export function getClosedGroupsLoader(ctx: RouteContext) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureInfiniteQueryData(
			getGroupsQueryOptions({ status: "closed" }),
		);
	}
	return ctx.queryClient.getQueryData([
		QUERY_KEYS.GET_GROUPS,
		{ status: "closed" },
	]);
}
